import { DefaultTheme } from "styled-components";

export const SecondaryTheme: DefaultTheme = {
    colors: {
        introBackground: "#E2EAFC",
        blogBackground: "#77BFA3",
        sideBar: "#5E548E",
        introCard: "#E0B1CB",
        black: "#000000",
        button: "#EDEEC9",
        techsBackground: "#72DDF7",
        aboutMeBackground: "#EDEEC9",
        pink: "#FF98F5",
        boxShadow: "#231942",
        phrase: "#E2EAFC",
    },
};
